import apiClient from "./config";

/**
 * ✅ GET CURRENT USER
 * GET /api/users/me
 */
export const fetchMe = async () => {
  try {
    const res = await apiClient.get("/users/me");
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: "Not authorized" };
  }
};

/**
 * ✅ UPDATE AVATAR
 * PUT /api/users/me/avatar
 * body: { avatarUrl }
 */
export const updateMyAvatar = async (avatarUrl) => {
  try {
    const res = await apiClient.put("/users/me/avatar", { avatarUrl });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: "Avatar update failed" };
  }
};

/**
 * ✅ UPDATE NAME (firstName + lastName)
 * PUT /api/users/me/name
 * body: { firstName, lastName }
 */
export const updateMyName = async ({ firstName, lastName }) => {
  try {
    const res = await apiClient.put("/users/me/name", { firstName, lastName });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: "Profile update failed" };
  }
};

/**
 * ✅ UPDATE ACADEMIC PROFILE (course, yearLevel, interests)
 * PUT /api/users/me/academic
 * body: { course, yearLevel, interests: string[] }
 */
export const updateMyAcademicProfile = async ({ course, yearLevel, interests }) => {
  try {
    const res = await apiClient.put("/users/me/academic", { course, yearLevel, interests });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: "Academic profile update failed" };
  }
};
